import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './pages/home';
import reportWebVitals from './reportWebVitals';
import "./css/slick.min.css"
import "./css/slick-theme.min.css"
import './css/animate.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/bootstrap.css'
import './css/style.css'
import './css/edit.css'
import './css/responsive.css'
import Thankyou from './pages/thankyou'
// import './css/ionicons.min.css'
import './css/ionicons.min.css'
import Login from "./admin/login"
import AdminDashbord from "./admin/dashboard"
import Dashboard from "./admin/dashboard_list"
import CenterList from "./admin/centerList"
import ContactReport from "./admin/contact_report"
import UserList from "./admin/userList"

// Function to dynamically render the appropriate component
function renderComponent() {
  const homeElement = document.getElementById('root');
  
  // Get the current path
  const path = window.location.pathname;

  // Function to remove an element by its ID
  function removeElementById(id) {
      const element = document.getElementById(id);
      if (element) {
          element.remove();
      }
  }
  
  const root = ReactDOM.createRoot(homeElement);
  root.render(
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/thankyou" element={<Thankyou />}/>
      <Route path="/cms-login" element={<Login />}/>
      <Route path="/dashboard" element={<AdminDashbord />}/>
      <Route path="/dashboard-list" element={<Dashboard />}/>
      <Route path="/centerList" element={<CenterList />}/>
      <Route exact path="/contact_report" element={<ContactReport />} />
      <Route exact path="/userList" element={<UserList/>} />
    </Routes>
  </BrowserRouter>
  );
}
// Call the function to render the appropriate component
renderComponent();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
